import TicketAlertsControl from './TicketAlertsControl';
import TicketAlertsPage from './TicketAlertsPage';

export default {
    TicketAlertsControl,
    TicketAlertsPage,
};